import { t, Instance } from 'mobx-state-tree';
import type { DiffPayloadV1, SuggestionCitationSummary, SuggestionResponse } from 'we-tree-api-client/v2';

export const SuggestionCitationModel = t.model('SuggestionCitationModel', {
  id: t.identifier,
  citationId: t.string,
  targetPath: t.maybeNull(t.string),
  supports: t.boolean,
  sourceTitle: t.maybeNull(t.string),
  sourceType: t.maybeNull(t.string),
  sourceUrl: t.maybeNull(t.string),
  detailLocator: t.maybeNull(t.string),
  notes: t.maybeNull(t.string),
  mediaAssetId: t.maybeNull(t.string)
});

export const SuggestionModel = t.model('SuggestionModel', {
  id: t.identifier,
  familyId: t.string,
  targetType: t.string,
  targetId: t.string,
  suggestionType: t.string,
  diffPayload: t.frozen<DiffPayloadV1>(),
  title: t.maybeNull(t.string),
  description: t.maybeNull(t.string),
  createdBy: t.string,
  createdByNickname: t.maybeNull(t.string),
  status: t.string,
  reviewedBy: t.maybeNull(t.string),
  reviewedAt: t.maybeNull(t.string),
  resolutionComment: t.maybeNull(t.string),
  createdAt: t.string,
  updatedAt: t.string,
  citations: t.optional(t.array(SuggestionCitationModel), [])
});

export type SuggestionModelType = Instance<typeof SuggestionModel>;

function mapCitation(c: SuggestionCitationSummary): Instance<typeof SuggestionCitationModel> {
  return SuggestionCitationModel.create({
    id: c.id,
    citationId: c.citationId,
    targetPath: c.targetPath ?? null,
    supports: c.supports ?? true,
    sourceTitle: c.sourceTitle ?? null,
    sourceType: c.sourceType ?? null,
    sourceUrl: c.sourceUrl ?? null,
    detailLocator: c.detailLocator ?? null,
    notes: c.notes ?? null,
    mediaAssetId: c.mediaAssetId ?? null
  });
}

export function createSuggestionModelFromResponse(response: SuggestionResponse): Instance<typeof SuggestionModel> {
  return SuggestionModel.create({
    id: response.id,
    familyId: response.familyId,
    targetType: response.targetType,
    targetId: response.targetId,
    suggestionType: response.suggestionType,
    diffPayload: response.diffPayload,
    title: response.title ?? null,
    description: response.description ?? null,
    createdBy: response.createdBy,
    createdByNickname: response.createdByNickname ?? null,
    status: response.status,
    reviewedBy: response.reviewedBy ?? null,
    reviewedAt: response.reviewedAt ?? null,
    resolutionComment: response.resolutionComment ?? null,
    createdAt: response.createdAt,
    updatedAt: response.updatedAt,
    citations: (response.citations ?? []).map(mapCitation)
  });
}
